import { render, staticRenderFns } from "./UtxoStake.vue?vue&type=template&id=19c8c0d6&scoped=true&"
import script from "./UtxoStake.vue?vue&type=script&lang=ts&"
export * from "./UtxoStake.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c8c0d6",
  null
  
)

export default component.exports